import React from "react";

export default function About() {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
      TheCocktailDB uses the original API TheCocktailDB that was built in 2015 to provide a free data source api for drinks online
in the hope that developers would build applications and cool projects ontop of it.
TheCocktailDB originated on the Kodi forums as a way to browse cocktail recipes on your TV.
      </p>
    </section>
  );
}
